module.exports = __webpack_public_path__ + "img/ipSwitchbanner.9d97b2f6.png";